export default __webpack_public_path__ + "static/11-css-attributes-a649c71f228bed19f679c915d1824d82.png";